export default {
    SET_TEACHERS(state, teachers) {
      state.teachers = teachers.data;
      state.teachersMeta=teachers.meta
    }
  };